<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'gear']"></fa-icon> Settings
        </h3>
      </div>

      <div class="bg-light p-3 rounded-lg rounded-2">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="k-form-horizontal">

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="email" class="form-label col-3 k-label">Email</label>
            <div class="col-8">
              <input appAutoFocus type="text" class="form-control" id="email" formControlName="email"
                class="form-control">
              <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="alert alert-danger">

                <div *ngIf="email?.errors?.['required']">
                  Email is required.
                </div>
                <div *ngIf="email?.errors && email?.errors?.['email']">Please, enter valid email address.</div>

              </div>
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="apiUrl" class="form-label col-3 k-label">API Base URL</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="apiUrl" id="apiUrl">
              <div *ngIf="apiUrl?.invalid && (apiUrl?.dirty || apiUrl?.touched)" class="alert alert-danger">

                <div *ngIf="apiUrl?.errors?.['required']">
                  URL address is required.
                </div>
              </div>
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="pollingPeriod" class="form-label col-3 k-label">Polling Period</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="pollingPeriod" id="pollingPeriod">
              <div *ngIf="pollingPeriod?.invalid && (pollingPeriod?.dirty || pollingPeriod?.touched)"
                class="alert alert-danger">

                <div *ngIf="pollingPeriod?.errors?.['required']">
                  Polling Period is required.
                </div>
                <div *ngIf="pollingPeriod?.errors?.['min']">
                  Minimum of 1500ms required.
                </div>
              </div>
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="dbUser" class="form-label col-3 k-label">Database Username</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="dbUser" id="dbUser">
            </div>
          </div>

          <div class="k-form-field">
            <label for="dbUserPw" class="form-label col-3 k-label">Database Password</label>
            <div class="col-8">
              <input type="password" id="dbUserPw" formControlName="dbUserPw" class="form-control">
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="tunnelDbUsername" class="form-label col-3 k-label">Tunnel Database Username</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="tunnelDbUsername" id="tunnelDbUsername">
            </div>
          </div>

          <div class="k-form-field">
            <label for="tunnelDbPw" class="form-label col-3 k-label">Tunnel Database Password</label>
            <div class="col-8">
              <input type="password" id="tunnelDbPw" formControlName="tunnelDbPw" class="form-control">
            </div>
          </div>

          <div class="mt-4 text-right" style="float: inline-end;">
            <button class="btn btn-primary m-1" type="submit" [disabled]="form.invalid || form.pristine"> Save</button>
            <button type="button" class="btn btn-secondary" (click)="cancelChanges()"> Cancel</button>
          </div>

        </form>
      </div>
    </div>
  </div>
  <!-- <div class="col-12 offset-lg-1 offset-xl-2" style="margin-left: auto; margin-right: auto;">

  </div> -->

</div>

<div kendoWindowContainer></div>

<div kendoDialogContainer></div>
